/*
Basic application card found on the Application page.
Props: Title, Subtitle, Icon, Link, and LinkAction
Icons use Material font icons: https://material.io/resources/icons/?style=baseline
 */

import React from 'react';
import { makeStyles } from "@mui/styles";
import {Card, CardHeader, CardActions, Button, CssBaseline, Grid } from "@mui/material";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import {useTheme} from "@mui/material/styles";
//import ApplicationCardStyles from "../../styles/jss/components/common/ApplicationCardStyles";
import withRouter from '../../helpers/withRouter';
import NewProjectDialog from "./NewProjectDialog";
import { useNavigate  } from "react-router-dom";
import { grey } from '@mui/material/colors';

//const useStyles = makeStyles(ApplicationCardStyles);

const ApplicationCard = props => {
    const [open, setOpen] = React.useState(false);
    //const classes = useStyles();
    const theme = useTheme();
    const { title, subtitle, icon, link, actionText, history, showDialog, dialogOptions} = props;
    const navigate = useNavigate();
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return(
        <Grid size={{ xs: 12, md: 6, lg: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <CssBaseline/>
            {showDialog &&
            <NewProjectDialog
                open={open}
                setOpen={setOpen}
                handleClose={() => handleClose()}
                title={dialogOptions.title}
                description={dialogOptions.description}
                inputs={dialogOptions.inputs}
                postUrl={dialogOptions.postUrl}
                app={dialogOptions.app}
                appApi={dialogOptions.appApi}
                updateData={() => console.log('New project created.')}
                navigate={navigate}
            />
            }
            <Card sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              justifyContent: 'center',
              cursor: 'pointer',
            }}>
                <CardHeader
                    sx={{ display: 'flex', alignItems: 'middle' }}
                    avatar={
                        <Icon color={grey[3]} sx={{
                          fontSize: theme.typography.h3.fontSize,
                          color: '#2196F3'
                        }}>
                            {icon}
                        </Icon>
                    }
                    title={title}
                    subheader={subtitle}
                    //classes={{title: classes.cardHeader}}
                    slotProps={{
                      title: {sx: {
                        fontSize: theme.typography.h6.fontSize, color: '#2196F3'
                      }}
                    }}
                    onClick={() => navigate(link)}
                />
                <CardActions sx={{ justifyContent: 'flex-end' }}>
                    {/*Add card action function logic if Nam confirms current mockup*/}
                    <Button
                        size="medium"
                        variant='text'
                        //classes={{root: classes.linkActionText}}
                        //TODO: IS & OK FOR STYLING ROOT?
                        sx={{
                          "&": {
                            color: '#2196F3',
                            '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0)'
                            }
                          }
                        }}
                        onClick={() => handleOpen()}
                    >
                        {actionText}
                    </Button>
                </CardActions>
            </Card>
        </Grid>
    )
}

ApplicationCard.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    link: PropTypes.string,
    icon: PropTypes.string,
    actionText: PropTypes.string,
    showDialog: PropTypes.bool
};

ApplicationCard.defaultProps = {
    title: "Application Title",
    subtitle: "Subtitle",
    link: '/',
    icon: 'apps',
    actionText: '+ New Project',
    showDialog: false
};

export default withRouter(ApplicationCard);